import { sendEvent, setAnalyticsTrigger, type TTrySubscriptionEvents } from '@core/analytics'

export const sendTrySubscriptionClick = (event: TTrySubscriptionEvents): void => {
    setAnalyticsTrigger(event.name)
    sendEvent(event)
}
